import { getUniversalFormDatas, universalOutSave } from '@/services/universalForm'
export default {
  namespaced: true,
  state: {
    submitting: false,
    formDefaultDatas: [],
    infoDatas: {},
    datasReady: false,
    deployDatas: {},
    formName: '',
    isBorder: false,
    styleDatas: {},
    payloadDatas: {},
    formItemData: {},
    codeHtml: ''
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
    },
    setFormDefaultDatas (state, datas) {
      state.formDefaultDatas = datas
    },
    setPayloadDatas (state, datas) {
      state.payloadDatas = datas
    },
    setInfoDatas (state, datas) {
      state.infoDatas = datas
    },
    setDatasReady (state, b) {
      state.datasReady = b
    },
    setDeployDatas (state, datas) {
      state.deployDatas = datas
    },
    setFormName (state, name) {
      state.formName = name
    },
    setIsBorder (state, b) {
      state.isBorder = b
    },
    setStyleDatas (state, datas) {
      state.styleDatas = datas
    },
    setFormItemData (state, datas) {
      state.formItemData = datas
    },
    setCodeHtml (state, html) {
      state.codeHtml = html
    }
  },
  actions: {
    async getFormDatas ({ state, commit }) {
      commit('setSubmitting', true)
      const chain = await getUniversalFormDatas()
        .onSuccess((raw) => {
          raw.config.forEach((item) => {
            item.isActive = false
          })
          commit('setFormDefaultDatas', raw.config)
          commit('setInfoDatas', raw.allConfig)
          commit('setDeployDatas', raw.deploy)
          commit('setStyleDatas', raw.style)
          commit('setFormName', raw.name)
          commit('setPayloadDatas', raw)
          commit('setDatasReady', true)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async universalFormSave ({ state, commit }) {
      commit('setSubmitting', true)
      const chain = await universalOutSave()
        .onSuccess((raw) => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    addClick () {
      window.onbeforeunload = function (e) {
        return false
      }
    },
    removeClick () {
      window.onbeforeunload = null
    }
  }
}
